// src/Preview.tsx
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getOrientation } from './utils/exif';
import './styles/buttons.css';      // Button style
import './styles/animations.css';   // ★ Animation

type Props = {
  file: FileSystemFileHandle | null;
  pickedCurrent: boolean;
  onToggleCurrent: () => void;
};

export function Preview({ file, pickedCurrent, onToggleCurrent }: Props) {
  const [src,    setSrc]    = useState<string | null>(null);
  const [rotate, setRotate] = useState<string>('none');
  const { t } = useTranslation();

  /* ---------- 画像読み込み & EXIF 回転補正 ---------- */
  useEffect(() => {
    if (!file) { setSrc(null); return; }
    (async () => {
      const f = await file.getFile();
      const o = await getOrientation(f);
      setSrc(URL.createObjectURL(f));
      setRotate(
        o === 6 ? 'rotate(90deg)'
      : o === 8 ? 'rotate(-90deg)'
      : o === 3 ? 'rotate(180deg)'
      : 'none'
      );
    })();
  }, [file]);

  const asideStyle = {
    padding: 16,
    position: 'relative',
    height: '100%',
    boxSizing: 'border-box',
  } as const;

  if (!file) {
    return (
      <aside className="preview-enter" style={asideStyle}>
        <div className="preview-wrapper">
          <div className="preview-placeholder">
            {t('preview-hint1')}
            <br />
            {t('preview-hint2')}
          </div>
        </div>
      </aside>
    );
  }

  if (!src) return null;

  return (
    <aside className="preview-enter" style={asideStyle}>
      {/* チェックトグルボタン */}
      <button
        className="btn-primary"
        onClick={onToggleCurrent}
        style={{
          position: 'absolute',
          top: 16,
          right: 16,
          zIndex: 20,
          background: pickedCurrent ? 'var(--ls-error)' : undefined,
        }}
        title={t('toggle-title')}
      >
        {pickedCurrent ? t('deselect') : t('select')}
      </button>

      <div className="preview-wrapper">
        <img
          src={src}
          alt=""
          style={{
            transform: rotate,
            display: 'block',
            borderRadius: 4,
          }}
        />
      </div>
    </aside>
  );
}
